import { createAction } from 'redux-act'

import { VoucherError, Voucher, AppliedVouchers, Offer, ConfiguredOffers } from '../types'

export const setAppliedVouchers = createAction<Voucher[]>('set applied vouchers')

export const getConfiguredOffersStart = createAction('get configured offers start')
export const getConfiguredOffersSuccess = createAction<ConfiguredOffers[]>(
  'get configured offers success',
)
export const getConfiguredOffersFail = createAction('get configured offers fail')

export const getVouchersStart = createAction('get voucher start')
export const getVouchersSuccess = createAction<Offer[]>('get voucher success')
export const getVouchersFail = createAction<VoucherError>('get voucher fail')

export const postVouchersStart = createAction('post voucher start')
export const postVouchersSuccess = createAction<AppliedVouchers>('post voucher success')
export const postVouchersFail = createAction<VoucherError>('post voucher fail')

export const deleteVouchersStart = createAction('delete voucher start')
export const deleteVouchersSuccess = createAction<AppliedVouchers>('delete voucher success')
export const deleteVouchersFail = createAction<VoucherError>('delete voucher fail')

export const storeDeletedVouchers = createAction<string>('store deleted voucher')
export const clearStoredDeletedVouchers = createAction<void>('clear stored deleted voucher')

export const setLastAppliedUnavailableVoucher = createAction<VoucherError | undefined>(
  'set last applied voucher was unavailable',
)
export const setPostingVoucherWithCode = createAction<string>('posting voucher with code')

export const clearErrors = createAction('clear voucher errors')
